import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';


export interface ISendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationFields {
  _ids: string[];
}


export interface ISendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationResponseFields {
  isSuccess: boolean;
}


export function sendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutation(fragment: string): DocumentNode {
  return gql`
        mutation sendCustomPriceUpdatedNotifyEmailDropshippingProductRequest (
        $_ids: [String]!
        ) {
        sendCustomPriceUpdatedNotifyEmailDropshippingProductRequest (
        _ids: $_ids
        ) {
        ...fragment
        }
        }
        fragment fragment on SendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useSendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutation<TData extends Partial<ISendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ sendCustomPriceUpdatedNotifyEmailDropshippingProductRequest: TData },
        ISendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationFields>,
) {
  return useMutation<{ sendCustomPriceUpdatedNotifyEmailDropshippingProductRequest: TData },
      ISendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutationFields>(
        sendCustomPriceUpdatedNotifyEmailDropshippingProductRequestMutation(fragment), options,
      );
}
